import { Link } from "react-router-dom";
import menuimg5 from "./assets/images/resource/menu-image-5.png";
import menuimg6 from "./assets/images/resource/menu-image-5.png";
import menuimg7 from "./assets/images/resource/menu-image-5.png";
import menuimg8 from "./assets/images/resource/menu-image-5.png";
import menuimg9 from "./assets/images/resource/menu-image-5.png";
import menuimg10 from "./assets/images/resource/menu-image-5.png";

export const faqs = [
  {
    foodCategory: "Breakfast",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Our Signature Breakfast</h6>
                    </div>
                    <div className="price">
                      <span>JD12.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Manakish, foul, hummus, labneh, cheese halloumi, falafel,
                    omlette, veggies platter, tea or American coffee
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Create the Omlette of your Choice</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Eggs, cheese, veggies, turkey, salami, served with hashbrown
                    potato & grill cherry tomato, mushroom
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Croissant stuffed with eggs</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Croissant stuffed with scrambled eggs, turkey, cheese baby
                    rocket
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Croque Madame</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Croque Madame croissant stuffed with turkey salami & cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Foul with condiment</h6>
                    </div>
                    <div className="price">
                      <span>JD2.50</span>
                    </div>
                  </div>
                  <div className="text desc">Foul with condiment</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Falafel with condiment</h6>
                    </div>
                    <div className="price">
                      <span>JD1.75</span>
                    </div>
                  </div>
                  <div className="text desc">Falafel with condiment</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Hummus with condiment</h6>
                    </div>
                    <div className="price">
                      <span>JD1.75</span>
                    </div>
                  </div>
                  <div className="text desc">Hummus with condiment</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Hummus with meat</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">Hummus with meat</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Fatteh hummus & batenjan</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Fatteh hummus & batenjan</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg10} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cheese halloumi</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Cheese halloumi</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Moufaraket potato</h6>
                    </div>
                    <div className="price">
                      <span>JD2.25</span>
                    </div>
                  </div>
                  <div className="text desc">Moufaraket potato</div>
                </div>
              </div>
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Kalayet banadoura with meat</h6>
                    </div>
                    <div className="price">
                      <span>JD5.50</span>
                    </div>
                  </div>
                  <div className="text desc">Kalayet banadoura with meat</div>
                </div>
              </div>
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pickles & olives</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">Pickles & olives</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Baked Oven",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Manakish zaatar</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">Manakish zaatar</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Manakish cheese</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Manakish cheese</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Manakish cheese & zaatar</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Manakish cheese & zaatar</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Manakish labneh with baby rocket</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Manakish labneh with baby rocket
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Manakish turkey & cheese</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">Manakish turkey & cheese</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Salad & Appetizers",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>L’exotique Quinoa Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD7.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Quinoa, shrimp, avocado, cucumber, spring onion, parsley
                    topped with beetroot cherry, vinaigrette green oil
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Greek Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD5.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Crispy lettuce, with fresh herbs, cherry tomato, bell
                    pepper, oregano, cheese, olive, sliced cucumber with french
                    dressing
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pomelo Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD6.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Baby rocket, lettuce, pomelo, avocado, cucumber, cherry
                    tomato, red cabbage, nuts, sesame seed, aioli citrus
                    dressing
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Kani Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD8.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Japanese crab with cucumber, carrot in Thai dressing topped
                    with crispy panko
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Famous Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD5.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Baby arugula leaves, quinoa, pomegranate, bell pepper
                    gazpacho, bread bruschetta toto fruity balsamic dressing
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Traditional Chicken Caesar Salad</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    A light refreshing mixture of crispy romaine lettuce,
                    seasoning chicken, croutons, parmesan cheese, home-made
                    caesar dressing
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Crunchy Halloumi Panzanella</h6>
                    </div>
                    <div className="price">
                      <span>JD6.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Crispy mixed leaves topped with cherry tomato confit,
                    halloumi cheese, green olive, strawberry, cucumber,
                    caramelized walnut, pesto citrus dressing
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Hot Appetizers",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cioconat Platter</h6>
                    </div>
                    <div className="price">
                      <span>JD12.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Mozzarella sticks, mexican cheese, jalapeños, chicken
                    tender, chicken mousakhan roll served with sweet chili &
                    honey mustard dip
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Dynamite Shrimp</h6>
                    </div>
                    <div className="price">
                      <span>JD8.00</span>
                    </div>
                  </div>
                  <div className="text desc">Dynamite Shrimp</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Shrimp Kunafa</h6>
                    </div>
                    <div className="price">
                      <span>JD7.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Fried shrimp rolled with kunafa dough served with sweet
                    chili
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Buffalo Chicken Tenders</h6>
                    </div>
                    <div className="price">
                      <span>JD5.50</span>
                    </div>
                  </div>
                  <div className="text desc">With pistachio & garlic dip</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Fried Fish Fingers</h6>
                    </div>
                    <div className="price">
                      <span>JD7.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    With tartar and beetroot aioli dip
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Potato Ball Croquettes</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">With cheese dip</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Nachos</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Topped with creamy fried beans, jalapeño, melted cheese
                    served with mexican salsa sour cream & avocado dip
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Mousakhan Roll</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Chicken Mousakhan Roll with Raita Sauce
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chili Fries</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Chili Fries</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>French Fries</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">French Fries</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Wedges Potatoes</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Wedges Potatoes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Pizza",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cioconat Pizza</h6>
                    </div>
                    <div className="price">
                      <span>JD8.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Tomato sauce, marinated chicken, pineapple, turkey, dry
                    tomato, baby spinach, mozzarella cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Alfredo Pizza</h6>
                    </div>
                    <div className="price">
                      <span>JD7.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Creamy chicken Alfredo, mushrooms cherry tomato, mozzarella
                    cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pizza Margarita</h6>
                    </div>
                    <div className="price">
                      <span>JD5.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Tomato sauce with mozzarella cheese
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pizza Siciliana</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Tomato sauce, mozzarella cheese, marinated grilled bell
                    pepper sliced fresh mushroom, Italian salami & fresh sliced
                    tomato
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pizza Vegetarian</h6>
                    </div>
                    <div className="price">
                      <span>JD6.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Tomato sauce, mozzarella cheese, bell pepper, mushroom,
                    cherry tomato
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Pasta",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Penne Arriabiata</h6>
                    </div>
                    <div className="price">
                      <span>JD5.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Penne pasta cooked with spicy tomato sauce and sliced black
                    olives
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Fettuccine Alfredo</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Is an Italian pasta dish tossed with butter and parmesan
                    cheese, chicken mushroom, pesto cream
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pasta Linguine</h6>
                    </div>
                    <div className="price">
                      <span>JD7.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Cooked with garlic seafood, fresh basil, rose sauce
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Sandwiches",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Our Signature Burger</h6>
                    </div>
                    <div className="price">
                      <span>JD7.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Our burger made fresh in house with angus beef chargrilled
                    served with classic burger garnish, BBQ mushroom, onion,
                    pickles American cucumber
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Pressed Italian Picnic</h6>
                    </div>
                    <div className="price">
                      <span>JD6.75</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Focaccia bread, marinated chicken, dry tomato, pesto,
                    buffalo mozzarella cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Steak Sandwiches</h6>
                    </div>
                    <div className="price">
                      <span>JD8.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Succulent shaved beef steak, mushroom, onion, creamy
                    mustard, melted cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Aroma Sandwich</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Garlic chicken with onion, mushroom, sundry tomato, dijon
                    mustard cream
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Beef Shawarma</h6>
                    </div>
                    <div className="price">
                      <span>JD7.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Marinated beef with tahini dip, pickles, tomatoes, onion
                    wrapped in tortilla bread
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Shawarma</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Marinated chicken with garlic paste, pickles, lettuce
                    wrapped in tortilla bread
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Enchilada</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Seasonal chicken wrap with tortilla bread, bell pepper,
                    onion, frisca, melted cheese
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Soup",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Seafood Vegetables Soup</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Seafood Vegetables Soup</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Mushroom</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Chicken Mushroom</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Casserole",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Tawook Provencal</h6>
                    </div>
                    <div className="price">
                      <span>JD8.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Grilled chicken cubes with butter garlic sauce mushroom,
                    emmental cheese baked in oven
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Seafood Termidore</h6>
                    </div>
                    <div className="price">
                      <span>JD10.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Sauted seafood with bell pepper, garlic, onion, mushroom,
                    creamy saffron sauce, melted cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Authentic Meatballs</h6>
                    </div>
                    <div className="price">
                      <span>JD9.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Stuffed meatball with cheese cooked with tomato concasse,
                    croquette potato
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Main Course",

    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Prime Beef Ribeye Silver</h6>
                    </div>
                    <div className="price">
                      <span>JD27.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Topped with mashed potato, vegetable sticks, fresh herbs
                    sauce
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Prime Beef Tenderloin</h6>
                    </div>
                    <div className="price">
                      <span>JD16.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Topped with mashed potato, vegetable puree’, mushroom sauce
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Grilled Salmon</h6>
                    </div>
                    <div className="price">
                      <span>JD13.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Marinated with crispy garlic pistachio topped with quinoa,
                    veggie mousse
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Creamy Garlic Chicken</h6>
                    </div>
                    <div className="price">
                      <span>JD10.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Seasoning chicken breast dredged in flour, parmesan cheese
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Chicken Kiev</h6>
                    </div>
                    <div className="price">
                      <span>JD10.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Fried chicken roll with flavorful cheese & butter spinach
                    wrapped in crumbs of bread
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Coffee & Tea",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Espresso</h6>
                    </div>
                    <div className="price">
                      <span>JD3.00</span>
                    </div>
                  </div>
                  <div className="text desc">Ristretto or Longo</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Doppio</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Doppio</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Espresso Macchiato</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Espresso Macchiato</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Espresso Cortado</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso shot with steamed milk shot
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Espresso Affogato</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso shot with vanilla ice cream
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cappuccino</h6>
                    </div>
                    <div className="price">
                      <span>JD4.10</span>
                    </div>
                  </div>
                  <div className="text desc">Cappuccino</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Café Latte</h6>
                    </div>
                    <div className="price">
                      <span>JD4.10</span>
                    </div>
                  </div>
                  <div className="text desc">Café Latte</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Salted Caramel Latte</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Salted Caramel Latte</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Spanish Latte</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso, condensed milk, steamed milk
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Dark Mocha</h6>
                    </div>
                    <div className="price">
                      <span>JD4.10</span>
                    </div>
                  </div>
                  <div className="text desc">Dark Mocha</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>White Mocha</h6>
                    </div>
                    <div className="price">
                      <span>JD4.10</span>
                    </div>
                  </div>
                  <div className="text desc">White Mocha</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cinnamon Dolce Latte</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso, cinnamon, caramel, vanilla, steamed milk whipped
                    cream
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Coco Mocha</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Dark chocolate sauce, coconut, espresso, steamed milk
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Lavender Coffee</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso, steamed milk, lavender
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Caramel Macchiato</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Caramel Macchiato</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Double Cream Brulee</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Espresso, steamed milk, cream brulee
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>American Coffee</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">American Coffee</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Americano</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Americano</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Turkish Coffee</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Turkish Coffee</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Nescafe</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Classic, gold, decaf</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Hot Chocolate</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Hot Chocolate</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Flavored Hot Chocolate</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">Flavored Hot Chocolate</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>White Chocolate</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">White Chocolate</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Regular Tea</h6>
                    </div>
                    <div className="price">
                      <span>JD3.25</span>
                    </div>
                  </div>
                  <div className="text desc">Regular Tea</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Flavored Tea</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Flavored Tea</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Karak Tea</h6>
                    </div>
                    <div className="price">
                      <span>JD3.75</span>
                    </div>
                  </div>
                  <div className="text desc">Karak Tea</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Cocktails",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cioconat Cocktail</h6>
                    </div>
                    <div className="price">
                      <span>JD4.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Pomegranate, orange, strawberry, vanilla ice cream
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Green Apple</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Mint ginger</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Mixed Fruit</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Banana, strawberry, orange, guava, mango
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Ginger Colada</h6>
                    </div>
                    <div className="price">
                      <span>JD4.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Coconut, passion fruit, pineapple, ginger
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Sunset Fruit</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Orange, pineapple, strawberry, passion fruit
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Dreamy Mango</h6>
                    </div>
                    <div className="price">
                      <span>JD4.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Orange, mango, strawberry, strawberry ice cream
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Avocado Coconut</h6>
                    </div>
                    <div className="price">
                      <span>JD5.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Avocado, vanilla ice cream, honey, coconut, milk whipped
                    cream
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Avocado Pomegranate</h6>
                    </div>
                    <div className="price">
                      <span>JD5.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Avocado, milk, pomegranate, vanilla ice cream whipped cream
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Sun Rise</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Banana, raspberry, mango, orange
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Apple Pie</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Banana, apple, vanilla, cinnamon, milk
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Blueberry Delight</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Coconut, blueberry, banana, yoghurt, milk, strawberry
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Mocktails",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Cioconat Special Mocktail</h6>
                    </div>
                    <div className="price">
                      <span>JD3.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Orange juice, cinnamon, strawberry, honey, soda
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Blackberry Green Apple</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Lemon rancho, blackberry, green apple, soda
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Basil Cherry Tomato</h6>
                    </div>
                    <div className="price">
                      <span>JD3.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Basil, cherry tomato, lemon juice, soda
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Lavender Yuzu Pure</h6>
                    </div>
                    <div className="price">
                      <span>JD3.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Yuzu pure, lavender, lemon rantcho, soda
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Blue Orange</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Blue caracao, orange, soda</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Passion Granate</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Pomegranate, passion fruit, soda
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Red Power</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Lemon juice, grenadine, red bull
                  </div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Rose Lemonade</h6>
                    </div>
                    <div className="price">
                      <span>JD3.40</span>
                    </div>
                  </div>
                  <div className="text desc">Rose, lemon juice, soda</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Blue Curacao</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">Lemon, sugar syrup, soda</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Juices & Smoothies",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-12 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>
                        Orange, Lemon, Mango, Strawberry Pineapple, Pomegranate,
                        Carrot Papaya, Kiwi Guava, Lemon Mint
                      </h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Orange, Lemon, Mango, Strawberry Pineapple, Pomegranate,
                    Carrot Papaya, Kiwi Guava, Lemon Mint
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Cold Coffee",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Iced Americano</h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">Iced Americano</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Iced Latté</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">Iced Latté</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Iced Mocha</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Iced Mocha</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Iced Spanish Latté</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Iced Spanish Latté</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Praline Ice Latté</h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">Praline Ice Latté</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Frappuccino</h6>
                    </div>
                    <div className="price">
                      <span>JD4.75</span>
                    </div>
                  </div>
                  <div className="text desc">Frappuccino</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Soft Drink",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Mineral Water</h6>
                    </div>
                    <div className="price">
                      <span>JD1.15</span>
                    </div>
                  </div>
                  <div className="text desc">Mineral Water</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Sparkling Water</h6>
                    </div>
                    <div className="price">
                      <span>JD2.25</span>
                    </div>
                  </div>
                  <div className="text desc">Sparkling Water</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Energy Drink</h6>
                    </div>
                    <div className="price">
                      <span>JD3.75</span>
                    </div>
                  </div>
                  <div className="text desc">Energy Drink</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>G Drink</h6>
                    </div>
                    <div className="price">
                      <span>JD3.50</span>
                    </div>
                  </div>
                  <div className="text desc">G Drink</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Barbican</h6>
                    </div>
                    <div className="price">
                      <span>JD3.75</span>
                    </div>
                  </div>
                  <div className="text desc">Barbican</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Coca-Cola, Sprite Zero, Fanta</h6>
                    </div>
                    <div className="price">
                      <span>JD2.75</span>
                    </div>
                  </div>
                  <div className="text desc">Coca-Cola, Sprite Zero, Fanta</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Iced Tea</h6>
                    </div>
                    <div className="price">
                      <span>JD3.75</span>
                    </div>
                  </div>
                  <div className="text desc">Iced Tea</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Mojito</h6>
                    </div>
                    <div className="price">
                      <span>JD4.25</span>
                    </div>
                  </div>
                  <div className="text desc">Mojito</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Fruity Frappe",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-12 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>
                        Green Apple, Kiwi, Grapefruit, Coconut, Peach,
                        Strawberry, Tangerine, Mango, Raspberry, Blueberry, Red
                        Berries
                      </h6>
                    </div>
                    <div className="price">
                      <span>JD4.50</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Green Apple, Kiwi, Grapefruit, Coconut, Peach, Strawberry,
                    Tangerine, Mango, Raspberry, Yuzu, Lychee, Passion Fruit,
                    Blueberry, Red Berries
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Yoghurt",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-12 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>
                        Strawberry, Mango, Blueberry, Passion Fruit Coconut,
                        Peach, Raspberry
                      </h6>
                    </div>
                    <div className="price">
                      <span>JD4.00</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Strawberry, Mango, Blueberry, Passion Fruit Coconut, Peach,
                    Raspberry
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Milkshake",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-12 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>
                        Vanilla, Chocolate, Strawberry, Arabia, KitKat, Caramel,
                        Croquant, Lotus, Nutella, Pistachio, Cheese Cake
                      </h6>
                    </div>
                    <div className="price">
                      <span>JD4.40</span>
                    </div>
                  </div>
                  <div className="text desc">
                    Vanilla, Chocolate, Strawberry, Arabia, KitKat, Caramel,
                    Croquant, Lotus, Nutella, Pistachio, Cheese Cake, All items
                    are topped with whipped cream
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
  {
    foodCategory: "Shisha",
    foodItem: (
      <section className="menu-two">
        <div className="row clearfix">
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg5} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Two Apples</h6>
                    </div>
                    <div className="price">
                      <span>JD7.00</span>
                    </div>
                  </div>
                  <div className="text desc">Two Apples</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg6} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Two Apple Mazaya</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Two Apple Mazaya</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg7} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Lemon & Mint</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Lemon & Mint</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Gum with Cinnamon</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Gum with Cinnamon</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Arrow Gum</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Arrow Gum</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Candy</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Candy</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Mestika</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Mestika</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Watermelon & Mint</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Watermelon & Mint</div>
                </div>
              </div>
            </div>
          </div>
          <div className="menu-col col-lg-6 col-md-12 col-sm-12">
            <div className="inner">
              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg9} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Grape</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Grape</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Grape & Mint</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Grape & Mint</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Grape with Berry</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Grape with Berry</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Orange & Mint</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Orange & Mint</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Special Fruit</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Special Fruit</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Mint</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Mint</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Blue Mist</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Blue Mist</div>
                </div>
              </div>

              <div className="dish-block">
                <div className="inner-box">
                  <div className="dish-image">
                    <img src={menuimg8} alt="" />
                  </div>
                  <div className="title clearfix">
                    <div className="ttl clearfix">
                      <h6>Zagloul</h6>
                    </div>
                    <div className="price">
                      <span>JD6.50</span>
                    </div>
                  </div>
                  <div className="text desc">Zagloul</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    ),
  },
];
